import * as React from "react";
import { twMerge } from "tailwind-merge";
import { SVGs } from "../assets";
import Text from "./Text";

export type PickerContainerClassNames = {
  label?: string;
  value?: string;
  icon?: string;
};

export type InputContainerProps = {
  className?: string;
  classNames?: PickerContainerClassNames;
  label?: string;
  value?: string;
  placeholder?: string;
  children?: React.ReactNode;
  onClick?: () => void;
};

export default function PickerContainer({
  label,
  value,
  placeholder,
  className,
  classNames,
  children = null,
  onClick,
}: InputContainerProps) {
  const displayValue = value?.trim?.() ? value : undefined;
  return (
    <button
      onClick={onClick}
      type="button"
      aria-label={label}
      className={twMerge(
        "relative flex h-[56px] w-full items-center justify-between rounded-[4px] border border-border bg-transparent px-[15px] text-left outline-none transition focus-visible:ring-2 focus-visible:ring-primary/25",
        className,
      )}
    >
      <Text
        level={5}
        className={twMerge(
          "absolute top-[-8px] left-[12px] z-10 max-w-[calc(100%-24px)] truncate bg-secondary px-[4px] text-text-surface",
          classNames?.label,
        )}
      >
        {label}
      </Text>
      {children ?? (
        <>
          <Text
            className={twMerge(
              "min-w-0 flex-1 truncate whitespace-nowrap text-text-surface",
              !displayValue && "font-thin",
              classNames?.value,
            )}
          >
            {displayValue ?? placeholder ?? ""}
          </Text>
          <SVGs.ChevronDown
            className={twMerge(
              "ml-2 w-[12.86px] shrink-0 text-text-surface",
              classNames?.icon,
            )}
          />
        </>
      )}
    </button>
  );
}
